export default "__VITE_ASSET__3mH5WGvF__"